
export const faqs = [
  {
    id: 0,
    title: `How does Falcon's pricing work?`,
    description: `The free version of Falcon is available for teams of up to 15 people. Our Falcon Premium plans of 15 or fewer qualify for a small team discount. As your team grows to 20 users or more and gets more value out of Falcon, you'll get closer to our standard monthly price per seat. The price of a paid Falcon plan is tiered, starting in groups of 5 and 10 users, based on the number of people you have in your Team or Organization.`
  },
  {
    id: 1,
    title: 'What forms of payment do you accept?',
    description: `You can purchase Falcon with any major credit card. For annual subscriptions, we can issue an invoice payable by bank transfer or check. Please contact us to arrange an invoice purchase. Monthly purchases must be paid for by credit card.`
  },
  {
    id: 2,
    title: 'We need to add more people to our team. How will that be billed?',
    description: `You can add as many new teammates as you need before changing your subscription. We will subsequently ask you to correct your subscription to cover current usage.`
  },
  {
    id: 3,
    title: `How secure is Falcon?`,
    description: `Protecting the data you trust to Falcon is our first priority. Falcon uses physical, procedural, and technical safeguards to preserve the integrity and security of your information. We regularly back up your data to prevent data loss and aid in recovery. Additionally, we host data in secure SSAE 16 / SOC1 certified data centers, implement firewalls and access restrictions on our servers to better protect your information, and work with third party security researchers to ensure our practices are secure.`
  },
  {
    id: 4,
    title: `Will I be charged sales tax?`,
    description: `As of May 2016, state and local sales tax will be applied to fees charged to customers with a billing address in the State of New York.`
  },
  {
    id: 5,
    title: `Do you offer discounts?`,
    description: `We've built in discounts at each tier for teams smaller than 15 members. We also offer two months for free in exchange for an annual subscription.`
  },
  {
    id: 6,
    title: `Do you offer academic pricing?`,
    description: `We're happy to work with student groups using Falcon. Contact Us`
  },
  {
    id: 7,
    title: `Is there an on-premise version of Falcon?`,
    description: `We are passionate about the web. We don't plan to offer an internally hosted version of Falcon. We hope you trust us to provide a robust and secure service so you can do the work only your team can do.`
  },
  {
    id: 8,
    title: `What is your refund policy?`,
    description: `We do not offer refunds apart from exceptions listed below. If you cancel your plan before the next renewal cycle, you will retain access to paid features until the end of your subscription period. When your subscription expires, you will lose access to paid features and all data associated with those features. Exceptions to our refund policy: canceling within 48 hours of initial charge will result in a full refund. If you cancel within this timeframe, you will lose access to paid features and associated data immediately upon canceling.`
  }
];

export const faqAccordions = [
  {
    id: 0,
    title: 'How long do payouts take?',
    description:
      '<p class = "mb-0">Once you’re set up, payouts arrive in your bank account on a 2-day rolling basis. Or you can opt to receive payouts weekly or monthly.</p>'
  },
  {
    id: 1,
    title: 'How do refunds work?',
    description:
      '<p class = "mb-0">You can issue either partial or full refunds. There are no fees to refund a charge, but the fees from the original charge are not returned.</p>'
  },
  {
    id: 2,
    title: 'How much do disputes costs?',
    description:
      '<p class = "mb-0">Disputed payments (also known as chargebacks) incur a $15.00 fee. If the customer’s bank resolves the dispute in your favor, the fee is fully refunded.</p>'
  },
  {
    id: 3,
    title: 'Is there a fee to use Apple Pay or Google Pay?',
    description:
      '<p class = "mb-0">There are no additional fees for using our mobile SDKs or to accept payments using consumer wallets like Apple Pay or Google Pay.</p>'
  }
];

export const faqDoc = [
  {
    id: 1,
    title: 'Login',
    img: 1,
    description: `<p class='mb-0'>Permite acceder al sistema ingresando el correo electrónico y contraseña previamente registrados.
Si los datos son correctos, se redirige al panel principal según el rol del usuario (administrador, profesor o alumno).
Si los datos son incorrectos, el sistema muestra un mensaje de error.

</p>`
  },
  {
    id: 2,
    img: 2,
    title:
      'Nuevo Usuario',
    description: `<p class="mb-0">Permite crear nuevos usuarios dentro del sistema.
Campos requeridos: nombre, email y contraseña.
Se debe seleccionar el rol del usuario
Los roles determinan los niveles de acceso y las acciones disponibles dentro del sistema.
El sistema valida que el email no esté repetido antes de guardar.
</p>`
  },

  {
    id: 3,
    img:3,
    title: 'Lista de Usuarios',
    description: `<p class="mb-0">Permite visualizar y verificar los usuarios creados, su rol y estado dentro del sistema.
Se puede confirmar si el usuario fue creado correctamente.
Visualización rápida del tipo de usuario (admin, docente, etc.)
Permite exportar la lista filtrada de usuarios a formato Excel desde el botón “Exportar”.
Ideal para reportes o respaldo administrativo.
El filtro previo puede hacerse por nombre, rol o fecha de creación.
</p>`
  },
  {
    id: 4,
    title: 'Nuevo Profesor',
    description: `<p class="mb-0">Permite crear el perfil de un profesor.
Campos requeridos: nombre, apellido, DNI, email, teléfono y área o materia asignada.
Se puede asociar el perfil del profesor a un usuario previamente creado.
El sistema valida que el DNI y email no estén duplicados.
</p>`
  },
  {
    id: 5,
    title:
      'Lista de Profesores',
    description: `<p class="mb-0">Visualiza todos los profesores registrados en el sistema.
Se puede filtrar por nombre, apellido, DNI o fecha de creación del perfil.
Ideal para búsqueda rápida o gestión de docentes activos.
Permite exportar la lista filtrada de profesores en formato Excel desde el botón “Imprimir”.
El archivo conserva los filtros aplicados.
</p>`
  },
  {
    id: 6,
    title: 'Nuevo Curso',
    description: `<p >Permite crear cursos académicos con sus características principales.
Campos requeridos: nombre del curso, nivel, capacidad máxima, turno y descripción.
Puede incluir la asignación de un profesor responsable.
El sistema valida que no se duplique el nombre del curso dentro del mismo nivel.
</p>`
  },
  {
    id: 7,
    title:
      'Lista de Cursos',
    description: `<p >Desde el botón Actualizar, se puede modificar directamente la capacidad del curso (número máximo de alumnos).
No requiere ingresar nuevamente al formulario de edición.
Permite filtrar los cursos por nivel, nombre o fecha de creación.
Facilita la gestión de múltiples cursos en diferentes etapas educativas.
La lista filtrada puede exportarse a Excel desde el botón “Imprimir”.
Útil para control académico o planificación anual.
</p>`
  },
  {
    id: 8,
    title: 'Nuevo Alumno',
    description: `<p class="mb-0">Permite crear un nuevo perfil de alumno.
Se completan los campos personales: nombre, apellido, DNI, dirección, fecha de nacimiento, correo y contacto del tutor.
También se puede asignar directamente un curso y estado de matrícula.
El sistema valida duplicados por DNI o email.
</p>`
  },
  {
    id: 9,
    title: 'Lista de Alumnos',
    description: `<p class='mb-0'> Muestra la lista general de estudiantes con sus datos más relevantes (nombre, curso, fecha de alta, etc.).
Incluye buscador y filtros por nombre, curso o estado.
    </p>`
  },
  {
    id: 10,
    title: 'Perfil Estudiante',
    description: `<p>Muestra los datos completos del estudiante seleccionando su nombre desde la lista.
Se puede editar o actualizar la información personal.
</p>`,
  },
  {
    id: 11,
    title: 'Notas',
    description: `Permite acceder a las calificaciones del alumno.
Vista detallada por materia, trimestre o año académico.
`
  },
  {
    id: 12,
    title: 'Acciones',
    description:  `<p>Acciones disponibles desde la lista o el perfil:
Asignar curso: cambiar o definir el curso al que pertenece el alumno.
Alta/Baja médica: activar o desactivar la cobertura del seguro médico del estudiante.
Eliminar alumno: elimina el registro definitivamente.
Botón “Más”: redirige a la ventana de pagos del alumno para gestionar sus cuotas o deudas.
</p>`
  },
  {
    id: 13,
    title:'Editar',
    description: `<p>Permite modificar los datos del alumno, incluyendo datos personales, curso asignado y estado.</p>`
  },
  {
    id: 14,
    title: 'Ventanas de Pago',
    description: `<p>Muestra la historia de pagos y las cuotas pendientes del alumno.
Se puede registrar pagos manuales, aplicar descuentos o anular transacciones.
</p>`
  },
  {
    id: 15,
    title: 'Vista de Tarjetas',
    description: `<p>Permite visualizar el detalle de cuotas de cada alumno en formato tipo tarjeta, con monto, estado y fecha.
</p>`
  },
  {
    id: 16,
    title: 'Ver Ticket',
    description: `<p>Permite abrir el comprobante correspondiente a una transacción específica.</p>`
  },
  {
    id: 17,
    title: 'Cajas',
    description: `<p>Suma automáticamente los pagos seleccionados al total a abonar.</p>`
  },
  {
    id: 18,
    title: 'Pagar Total',
    description: `<p>Confirma el pago completo del monto total mediante el botón “Pagar”.
Se actualiza automáticamente el estado de cada cuota a “Pagada”.
</p>`
  },
  {
    id: 19,
    title: 'Descuentos',
    description: `<p>Permite aplicar descuentos personalizados a los alumnos.
Tipos de descuento: porcentaje (%), monto fijo o beca completa.
El sistema recalcula el monto total a pagar automáticamente.
Los descuentos aplicados quedan registrados en la ficha del alumno.
</p>`
  },
  {
    id: 20,
    title: 'Reportes',
    description: `<p>Permite visualizar reportes de ingresos económicos.
Se eligen rangos de fechas desde los inputs para filtrar los períodos de análisis.
Los resultados se muestran por método de pago (efectivo, transferencia, tarjeta, etc.).
Se presentan en valores numéricos y gráficos de barras para una mejor interpretación.
Herramienta clave para control contable y gestión financiera.
</p>`
  },
  {
    id: 21,
    title: 'Meses',
    description: `<p>Permite seleccionar un mes específico del calendario académico.</p>`
  },
  {
    id: 22,
    title: 'Seleccionar Mes',
    description: `<p>Muestra el estado de los pagos o cuotas del mes seleccionado.
Se pueden filtrar por nombre, apellido o fecha de creación del link de pago.
Útil para seguimiento mensual de pagos y alumnos pendientes.
</p>`
  },
  {
    id: 23,
    title: 'Cuotas',
    description: `<p>Gestiona todas las cuotas mensuales o periódicas de los alumnos.
Permite ver el detalle de pagos, fechas de vencimiento y estado (pendiente, abonado, vencido).
Se pueden aplicar descuentos, generar links de pago o registrar cobros manuales.
Es posible filtrar por curso, alumno o mes, y exportar la información a Excel.
</p>`
  }



  

];
